import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export const contactTypeSchema = z.literal(["nurse", "helper", "family", "unknown"]);
export type ContactType = z.infer<typeof contactTypeSchema>;

export type Contact = {
  id: string;
  phone: string;
  isEmergencyContact: boolean;
  contactType: ContactType;

  firstName?: string;
  lastName?: string;
  email?: string;
  postalAddress?: string;
  comment?: string;
};

export const contactSchema: Schema<Contact> = cz.camelCaseObject({
  id: cz.id(),
  phone: z.string(),
  first_name: cz.optional(z.string()),
  last_name: cz.optional(z.string()),
  email: cz.optional(z.string()),
  postal_address: cz.optional(z.string()),
  comment: cz.optional(z.string()),
  is_emergency_contact: z.boolean(),
  contact_type: contactTypeSchema,
});

export type CreateContact = {
  phone: string;

  first_name?: string;
  last_name?: string;
  email?: string;
  postal_address?: string;
  comment?: string;
  is_emergency_contact?: boolean;
  contact_type?: ContactType;
};

export const contactTypeTranslation = (type: string | undefined): string => {
  switch (type) {
    case "nurse":
      return "models.contactType.nurse";
    case "helper":
      return "models.contactType.helper";
    case "family":
      return "models.contactType.family";
    default:
      return "models.contactType.unknown";
  }
};
